'use strict'

module.exports = [
  { suffix: '日' }
]
